import React, { useState } from 'react'
import { Tabs, Tab } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import SwipeableViews from 'react-swipeable-views'
import { useParams } from 'react-router-dom'
import { a11yProps } from '../../../services/helper'
import TabPanel from '../../../components/TabPanel'
import { useLoanContext } from '../../../contexts/LoanContext'
import AlertBox from '../../../components/AlertBox'
import Heading from '../../../components/Heading'
import LoanComparisonTemplate from './components/LoanComparisonTemplate'
import LoanCalculatorTemplate from './components/LoanCalculatorTemplate'
import useUser from '../../../hooks/useUser'
import { useLoanLockedContext } from '../../../contexts/LoanLockedContext'

export type LoanCalculatorContentProps = {
	className?: string
}

export default function LoanCalculatorContent({
	className = '',
}: LoanCalculatorContentProps) {
	const { loanId } = useParams()
	const themeMUI = useTheme()
	const { loan } = useLoanContext()
	const { isLoanAdmin } = useUser()
	const { isLocked } = useLoanLockedContext()

	const [selectedTab, setSelectedTab] = useState(0)

	const tabRoutes = [
		{
			key: 'loanCalculatorAdjustments',
			title: 'Adjustments',
			index: 0,
		},
		{
			key: 'loanComparison',
			title: 'Loan Comparison',
			index: 1,
			disabled: loan?.isLocked,
		},
	]

	const handleTabChange = (
		event: React.SyntheticEvent,
		value: number
	) => {
		setSelectedTab(value)
	}

	const handleChangeIndex = (index: number) => {
		setSelectedTab(index)
	}

	return (
		<div className={className}>
			<Heading className="my-2">Loan Calculator</Heading>

			{isLocked && (
				<AlertBox severity="warning" className="mb-4">
					The loan is currently in use in Encompass. The calculator
					cannot be used until the user exits the loan.
				</AlertBox>
			)}
			{isLoanAdmin && (
				<Tabs value={selectedTab} onChange={handleTabChange}>
					{tabRoutes.map((route) => (
						<Tab
							value={route.index}
							label={route.title}
							key={route.key}
							disabled={route.disabled}
							{...a11yProps(route.index)}
						/>
					))}
				</Tabs>
			)}
			<SwipeableViews
				axis={themeMUI.direction === 'rtl' ? 'x-reverse' : 'x'}
				index={selectedTab}
				onChangeIndex={handleChangeIndex}
			>
				<TabPanel
					value={selectedTab}
					index={0}
					dir={themeMUI.direction}
				>
					{loanId && <LoanCalculatorTemplate />}
				</TabPanel>
				<TabPanel
					value={selectedTab}
					index={1}
					dir={themeMUI.direction}
				>
					{loanId && <LoanComparisonTemplate />}
				</TabPanel>
			</SwipeableViews>
		</div>
	)
}
